import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const Forbidden403NotIT = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle="Beklager, du må være IT-medlem for å kunne besøke denne siden"
      extra={
        <Link to="/admin/">
          <Button type="primary">Tilbake til dashboardet</Button>
        </Link>
      }
    />
  );
};

export default Forbidden403NotIT;
